import React from 'react';
import ImageUploadField from './ImageUploadField';
import { useMediaMetaProps } from './useMediaMetaProps';

/**
 * Image d'une prop du bloc sélectionné, avec ses props voisines (paliers,
 * variable du CRM, réglages de formulaire). Composant : il tient des hooks.
 */
export function BlockImageField({
  name, label, value, onChange, focalPointProp,
}) {
  const {
    meta, onMediaChange, form, onFormChange, focalPoint, onFocalPointChange,
  } = useMediaMetaProps(name, { focalPointProp });

  return (
    <ImageUploadField
      value={value}
      onChange={onChange}
      onMediaChange={onMediaChange}
      meta={meta}
      form={form}
      onFormChange={onFormChange}
      fieldLabel={label}
      focalPoint={focalPoint}
      onFocalPointChange={onFocalPointChange}
    />
  );
}

/** Champ Puck personnalisé : URL + upload + glisser-déposer + banque. */
export function puckImageField(label, { focalPointProp } = {}) {
  return {
    type: 'custom',
    label,
    render: ({ name, onChange, value }) => (
      <BlockImageField name={name} label={label} value={value} onChange={onChange} focalPointProp={focalPointProp} />
    ),
  };
}
